import { HambergurIcon, ProfileIcon, TypographyLogo } from '../../../assets/icons';
import { useSelector, useDispatch } from '../../../store/store';
import { setSideBarShow } from '../../../store/workspace/slice';
import { useNavigate } from 'react-router-dom';
import styles from './style.module.scss';
import {
    selectLogoImage,
    selectSideBarShow,
} from '../../../store/workspace/selectors';

function Header() {
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const userLogo = useSelector(selectLogoImage);
    const sideBarShow = useSelector(selectSideBarShow);

    return (
        <div className={styles.container}>
            <HambergurIcon
                className={styles.hambergur}
                onClick={() => dispatch(setSideBarShow(!sideBarShow))}
            />
            <TypographyLogo
                width={160}
                height={43}
                className={styles.logo}
                onClick={() => navigate('/workspace')}
            />
            <div className={styles.profile}>
                {/* <div className={styles.profile_notification}>
                    <AlertIcon />
                    <span></span>
                </div> */}
                <div className={styles.profile_avatar}>
                    {userLogo ? <img
                        src={userLogo}
                        alt="logo"
                    /> : <ProfileIcon />}
                </div>
            </div>
        </div>
    );
};

export default Header;
